export default __webpack_public_path__ + "static/media/m1.a17c1a38.jpg";